import Model, { attr, belongsTo } from "@ember-data/model";
import { service } from "@ember/service";
import { tKey } from "ember-intl";
import { task } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class BlockStorageVolumeModel extends Model {
  @service http;

  @attr name;
  @attr sizeInGib;
  @attr status;
  @attr dataCenter;
  @attr tier;
  @attr attachments;
  @attr wwn;
  @attr createdAt;
  @attr updatedAt;

  @belongsTo("project", { async: false, inverse: "blockStorageVolumes" }) project;

  get attachment() {
    return this.attachments?.[0] ?? null;
  }

  get isReady() {
    return this.status === "READY" && Boolean(this.wwn);
  }

  get isUpdating() {
    return this.status === "UPDATING";
  }

  get statusIndicator() {
    if (this.isReady) {
      return { state: "online", labelKey: tKey("label.online") };
    }

    if (this.isUpdating) {
      return { state: "busy", labelKey: tKey("block-storage-volumes.status.updating") };
    }

    return { state: "busy", showSpinner: true, labelKey: tKey("block-storage-volumes.status.creating") };
  }

  deleteTask = task(async () => {
    try {
      this.deleteRecord();
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();

      throw error;
    }
  });

  attachTask = task(async (serverid) => {
    let response = await this.http.request({
      url: `${ENV.apiBaseUri}/blockstorage/attach`,
      method: "POST",
      body: { volumeid: this.id, serverid },
    });

    this.pushUpdating(response.content.volume);
  });

  detachTask = task(async () => {
    let response = await this.http.request({
      url: `${ENV.apiBaseUri}/blockstorage/detach`,
      method: "POST",
      body: { volumeid: this.id },
    });

    this.store.pushPayload("block-storage-volume", { blockStorageVolume: response.content.volume });
  });

  pushUpdating(volume) {
    this.store.pushPayload("block-storage-volume", { blockStorageVolume: { ...volume, status: "UPDATING" } });
  }
}
